import request from '@/modules/base/util/request'
import config from '@/modules/settings/config'

export const TextModuleService = {
  getAll: () => {
    return new Promise((resolve, reject) => {
      request(config.textModules, {
        method: 'GET',
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },
  getAllDefaults: () => {
    return new Promise((resolve, reject) => {
      request(config.textModule, {
        method: 'GET',
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },
  getById: (id) => {
    return new Promise((resolve, reject) => {
      request(`${config.textModule}/${id}`, {
        method: 'GET',
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  create: (data) => {
    return new Promise((resolve, reject) => {
      request(`${config.textModule}`, {
        method: 'POST',
        data,
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },
  update: (id, data) => {
    return new Promise((resolve, reject) => {
      request(`${config.textModule}/${id}`, {
        method: 'PUT',
        data,
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },
  delete: (id) => {
    return new Promise((resolve, reject) => {
      request(`${config.textModule}/${id}`, {
        method: 'DELETE',
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },
}
